import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getHastaSayisi, getDashboardOzet } from '../services/api';

export default function Dashboard() {
  const navigate = useNavigate();
  const kullanici = JSON.parse(localStorage.getItem('kullanici') || '{}');
  const [hastaSayisi, setHastaSayisi] = useState(null);
  const [randevuSayisi, setRandevuSayisi] = useState(null);
  const [bekleyenMuayene, setBekleyenMuayene] = useState(null);

  useEffect(() => {
    getHastaSayisi().then(res => setHastaSayisi(res.data.sayi)).catch(() => setHastaSayisi('-'));
    getDashboardOzet().then(res => {
      setRandevuSayisi(res.data.randevuSayisi);
      setBekleyenMuayene(res.data.bekleyenMuayene);
    }).catch(() => { setRandevuSayisi('-'); setBekleyenMuayene('-'); });
  }, []);

  const kutular = [
    { ikon: '🧑‍🤝‍🧑', renk: '#7C5CBF', bg: '#f0eaff', deger: hastaSayisi ?? '…', etiket: 'Kayıtlı Hasta', yol: '/hastalar' },
    { ikon: '📅', renk: '#1D9E75', bg: '#e6f7f0', deger: randevuSayisi ?? '…', etiket: 'Bugünkü Randevu', yol: '/randevulari-gor' },
    { ikon: '🩺', renk: '#d97706', bg: '#fff3e0', deger: bekleyenMuayene ?? '…', etiket: 'Bekleyen Muayene' },
  ];

  return (
    <div>
      <h1 className="sayfa-baslik">Hoş geldiniz, {kullanici.adSoyad} 👋</h1>
      <p className="sayfa-alt">Klinik yönetim paneline genel bakış.</p>

      <div className="stat-grid">
        {kutular.map((k, i) => (
          <div key={i} className="stat" onClick={() => k.yol && navigate(k.yol)}
               style={{ cursor: k.yol ? 'pointer' : 'default' }}>
            <div className="stat-ikon" style={{ background: k.bg, color: k.renk }}>{k.ikon}</div>
            <div className="stat-deger">{k.deger}</div>
            <div className="stat-etiket">{k.etiket}</div>
          </div>
        ))}
      </div>

    </div>
  );
}
